export default "__VITE_ASSET__DrC6APcE__"